<template>
  <div class="tr">
    <div
      class="th"
      v-for="col of columns"
      @click="eventEmitter(col)"
      :style="col.style"
      :key="col.index"
      scope="col"
    >
      <span>{{col.string}}</span>
      <div :trItem="col" :is="col.componentName"></div>
      <div v-for="child of col.children" :style="child.style" :key="child.index">
        <span :style="child.style">{{child.string}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "crudTableHeader",
  directives: {},
  props: ["columns", "options"],
  data() {
    return {
      //VARIABILI AMBIENTE
      /*
      sorgente dati
      configurazione header
      recuperare parametri dall url
      configurazione pulsanti azione
      inject style personale
      tipo di stampa quadratini o righe

      quando premo su riga tabella prendo sorgente e ci aggiungo l id e rimando al link tramite route push
      */
    };
  },
  computed: {},
  methods: {
    eventEmitter(col) {
      this.$parent.$emit("crudTableHeaderEvent", col);
    }
  },
  mounted() {},
  watch: {}
};
</script>

<style scoped>
.tr {
  display: flex;
  margin-left: 2.5vw;
  margin-right: 2.1vw;
}

.th {
  border-radius: 10px;

  height: 3.5vh;
  line-height: 3.5vh;
}

.th span {
  /*background-color:white;*/
  font-size: 1em;
  font-weight: 600;
  color: #757575;
  border-radius: 20px;
  padding-top: 1vh;
  padding-bottom: 1vh;
}

main .table td,
.table .th {
  padding: 8px;
  vertical-align: middle;
}
</style>
